var map = {
	"./Auth.vue": [
		839
	],
	"./Catalog.vue": [
		7584,
		584
	],
	"./CustomSection.vue": [
		5025,
		25
	],
	"./NewOrder.vue": [
		3627,
		627
	],
	"./OrderDetail.vue": [
		2637,
		145
	],
	"./Orders.vue": [
		7767,
		767
	],
	"./PaymentDetail.vue": [
		892,
		892
	],
	"./Pays.vue": [
		5743,
		743
	],
	"./PersonalMenu.vue": [
		1987,
		987
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5393;
module.exports = webpackAsyncContext;